'use client';

/* empty css                          */
var textColorValues = { "onLight.text.primary": "#12151A" };
var onActionColorValues = { "onAction.primary.light": "var(--c5-26-5_2lwccm8, #1336B2)", "onAction.primary.dark": "var(--c5-26-5_2lwccma, #F2FBFF)" };
export {
  onActionColorValues,
  textColorValues
};
